module.exports = require("@emcm-ui/component-link");
